// v1.1.0 · Encabezado de la web pública
// v1.4.0 · Logo más grande
// v1.21.0 · Sobre la portada oscura el encabezado se vuelve translúcido oscuro (texto claro y logo sobre papel)
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, LogIn, CreditCard } from 'lucide-react';
import { nav, LOGO } from '../../data/site';

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [onDark, setOnDark] = useState(true);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 8);
      const imm = document.getElementById('inicio');
      setOnDark(Boolean(imm && imm.getAttribute('data-testid') === 'site-immersive' && imm.getBoundingClientRect().bottom > 90));
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors ${
        onDark && !open ? 'hdr-dark'
          : scrolled || open ? 'bg-white/95 backdrop-blur border-b border-[var(--line)]' : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex h-[76px] max-w-[1240px] items-center gap-6 px-5 sm:h-[88px] sm:px-8">
        <a href="#inicio" className="flex shrink-0 items-center gap-3" aria-label="Analytica, ir al inicio">
          <img src={LOGO} alt="" className="hdr-logo h-[52px] w-auto sm:h-[64px]" />
        </a>

        <nav className="hdr-nav ml-auto hidden items-center gap-7 lg:flex" aria-label="Principal">
          {nav.map((n) => (
            <a key={n.href} href={n.href} className="text-[15px] font-medium text-[var(--ink-2)] hover:text-[var(--ink)]">
              {n.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-2 lg:ml-0">
          <Link to="/login" title="Portal de clientes y equipo" aria-label="Portal de clientes y equipo"
                className="hdr-icon hidden rounded-lg p-2 text-[var(--ink-2)] hover:bg-[var(--paper)] hover:text-[var(--ink)] sm:block"
                data-testid="header-login-link">
            <LogIn size={18} />
          </Link>
          <Link to="/checkout" title="Pagos en línea" aria-label="Pagos en línea"
                className="hdr-icon hidden rounded-lg p-2 text-[var(--ink-2)] hover:bg-[var(--paper)] hover:text-[var(--ink)] sm:block"
                data-testid="header-checkout-link">
            <CreditCard size={18} />
          </Link>
          <a href="#contacto" className="btn-go !hidden !py-2.5 text-[15px] lg:!inline-flex">Cotizar proyecto</a>
          <button className="hdr-menu rounded-lg p-2 lg:hidden" onClick={() => setOpen((o) => !o)}
                  aria-expanded={open} aria-label={open ? 'Cerrar menú' : 'Abrir menú'}>
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-[var(--line)] bg-white px-5 pb-5 pt-2 lg:hidden" aria-label="Menú móvil">
          {nav.map((n) => (
            <a key={n.href} href={n.href} onClick={() => setOpen(false)}
               className="block border-b border-[var(--line)] py-3.5 text-[17px] font-semibold">
              {n.label}
            </a>
          ))}
          <a href="#contacto" onClick={() => setOpen(false)} className="btn-go mt-4 w-full justify-center">
            Cotizar proyecto
          </a>
          <div className="mt-4 flex justify-center gap-6 text-sm text-[var(--ink-2)]">
            <Link to="/login" data-testid="mobile-login-link" className="flex items-center gap-2"><LogIn size={16} /> Portal</Link>
            <Link to="/checkout" data-testid="mobile-checkout-link" className="flex items-center gap-2"><CreditCard size={16} /> Pagos</Link>
          </div>
        </nav>
      )}
    </header>
  );
}
